import { c as _c } from "react/compiler-runtime";
import { CICType } from "@/entities/IProfile";
import { cicToType } from "@/helpers/Helpers";
import UserCICAccurateIcon from "./icons/UserCICAccurateIcon";
import UserCICUnknownIcon from "./icons/UserCICUnknownIcon";
import UserCICInaccurateIcon from "./icons/UserCICInaccurateIcon";
import UserCICProbablyAccurateIcon from "./icons/UserCICProbablyAccurateIcon";
import UserCICHighlyAccurateIcon from "./icons/UserCICHighlyAccurateIcon";
import type { JSX } from "react";
export default function UserCICTypeIcon(t0) {
  const $ = _c(7);
  const {
    cic
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <UserCICInaccurateIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <UserCICUnknownIcon />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <UserCICProbablyAccurateIcon />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <UserCICAccurateIcon />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      [CICType.INACCURATE]: t1,
      [CICType.UNKNOWN]: t2,
      [CICType.PROBABLY_ACCURATE]: t3,
      [CICType.ACCURATE]: t4,
      [CICType.HIGHLY_ACCURATE]: <UserCICHighlyAccurateIcon />
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const COMPONENTS = t5;
  const t6 = COMPONENTS[cicToType(cic)];
  let t7;
  if ($[5] !== t6) {
    t7 = <div>{t6}</div>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}